export const SET_APP_SETTINGS = '[APP SETTINGS] SET APP SETTINGS'

export const setAppSettings = (settings) => ({
  type: SET_APP_SETTINGS,
  settings,
})
